import { Command } from 'src/api/command';
import { ApiClient } from 'src/api/ws-clilent';

export abstract class CommandsBase {
  protected readonly client: ApiClient;
  protected commandService = 'unknown';

  constructor(props: { client: ApiClient; service: string }) {
    this.client = props.client;
    this.commandService = props.service;
  }

  command(action: string, service?: string) {
    return new Command(service ? service : this.commandService, action);
  }

  setCommandService(service: string) {
    this.commandService = service;
  }
}
